import React, { useState } from 'react';
import { Tabs } from 'antd';
import DefaultEstimatorSettings from './DefaultEstimatorSettings';
import PortPurposeSettings from './PortPurposeSettings';

const EstimatorSettings = () => {
	const [activeTab, setActiveTab] = useState('defaultSettings');

	return (
		<Tabs
			activeKey={activeTab}
			onChange={setActiveTab}
			items={[
				{
					key: 'defaultSettings',
					label: 'Default settings',
					children: <DefaultEstimatorSettings />,
				},
				{
					key: 'portPurposeSettings',
					label: 'Port purposes',
					children: <PortPurposeSettings />,
				},
			]}
		/>
	);
};

export default EstimatorSettings;